/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL1(props) {
  return (
    <div className={`s-ou-l1 ${css(styles.group, styles.group_layout)}`}>
      <Px
        style={{
          '--src': `url(${
            require('assets/f85d6954cfac671236e2a486bf10055c.svg').default
          })`
        }}
        x="0px 1440fr 0px"
        y="1193fr minmax(0px, max-content) 0px"
        absolute
        className={css(styles.cover_group)}
        lgX="0px 1440fr 0px"
        lgY="597fr minmax(0px, max-content) 0px"
        mdX="0px 1440fr 0px"
        mdY="299fr minmax(0px, max-content) 0px"
        smX="0px 1440fr 0px"
        smY="150fr minmax(0px, max-content) 0px"
        xsX="0px 1440fr 0px"
        xsY="75fr minmax(0px, max-content) 0px"
      >
        <div className={css(styles.group1, styles.group1_layout)}>
          <div
            style={{
              '--src': `url(${
                require('assets/aa13de5cd56c794b3f0d328531e42ef2.svg').default
              })`
            }}
            className={css(styles.decorator, styles.decorator_layout)}
          />
          <div
            style={{
              '--src': `url(${
                require('assets/fb22768ad71b58de66ac84dd6cb51d01.svg').default
              })`
            }}
            className={css(styles.icon, styles.icon_layout)}
          />
        </div>
      </Px>

      <div className={css(styles.content_box, styles.content_box_layout)}>
        <div className={css(styles.content_box_item)}>
          <div
            style={{
              '--src': `url(${
                require('assets/e4f6dd38d10e5b775ee8d14a39fa6a62.svg').default
              })`
            }}
            className={css(styles.image, styles.image_layout)}
          />
        </div>
        <div className={css(styles.content_box_item1)}>
          <div className={css(styles.cover_group1, styles.cover_group1_layout)}>
            {/* All done except for XS Q_Q */}

            <div className={css(styles.flex, styles.flex_layout)}>
              <div className={css(styles.component, styles.component_layout)}>
                <HeaderBlack
                  icon={
                    require('assets/d322d14b233070bbff024a1a56d1eb66.png')
                      .default
                  }
                  image={
                    require('assets/c6b10e4947e78c4196251481415c35c3.png')
                      .default
                  }
                />
              </div>

              <div
                style={{
                  '--src': `url(${
                    require('assets/28e9611c8232f9e4ec4fb0fe06a5e35e.png')
                      .default
                  })`
                }}
                className={css(styles.cover_group2, styles.cover_group2_layout)}
              >
                <div
                  style={{
                    '--src': `url(${
                      require('assets/51881bc2891a0efa776bad09989acd6f.png')
                        .default
                    })`
                  }}
                  className={css(styles.image, styles.image_layout1)}
                />
              </div>

              <h4 className={css(styles.highlights, styles.highlights_layout)}>
                {'你/妳的靈魂是'}
              </h4>
              <h1 className={css(styles.big_title, styles.big_title_layout)}>
                {'大山大海的子民'}
              </h1>
              <h5
                className={css(styles.highlights1, styles.highlights1_layout)}
              >
                {
                  '有著自然奔放的性格與樸實的底蘊，不媚世俗，擁有豐富的智慧內涵。訴求穿著簡單自然的你，不炫耀、不誇示，謙卑而自信，保留真實的自己，讓人越來越想要靠近。'
                }
              </h5>

              <div
                onClick={() => window.open('/soul', '_self')}
                className={`${css(
                  styles.cover_group3,
                  styles.cover_group3_layout
                )} cursor-pointer to-more`}
              >
                {/* link to 8格結果頁 */}
                {'五感靈魂樣貌'}
              </div>

              <div
                style={{
                  '--src': `url(${
                    require('assets/78d56b7ddda1e75b437c4cc0caa15e06.png')
                      .default
                  })`
                }}
                className={css(styles.image2, styles.image2_layout)}
              />
              <h4
                className={css(styles.highlights2, styles.highlights2_layout)}
              >
                {'專屬於你的風味想像'}
              </h4>
              <div
                className={css(
                  styles.paragraph_body,
                  styles.paragraph_body_layout
                )}
              >
                {
                  '闊葉林的樹下、落葉遍佈的土壤、南島暖陽、海浪沖刷沙灘微微的鹽分。既是森林也是海岸，一個轉彎襲來的清風，帶來春天的小黃花還有自然青草的沁涼，也吹來秋季下過雨的溼氣與發酵氣息，不是滂沱無邊的亞馬遜雨林，而是島上小而精緻的台東。'
                }
              </div>
              <h4
                className={css(styles.highlights3, styles.highlights3_layout)}
              >
                {'推薦給你：縱谷間的茶・經典有機紅烏龍'}
              </h4>
              <div
                className={css(
                  styles.paragraph_body,
                  styles.paragraph_body_layout1
                )}
              >
                {
                  '這一款茶是女兒可以卸下一切，真實傾吐的「樹洞」。它讓人可以保持真實，不用刻意活出別人期待的樣子。擁有讓人放鬆的力量，始於自然的豐富香氣，打造暫時逃離現實的出口、一個人的小世界。'
                }
              </div>

              <div className={css(styles.flex1, styles.flex1_layout)}>
                <div className={css(styles.flex1_item)}>
                  <div
                    className={css(
                      styles.cover_group4,
                      styles.cover_group4_layout
                    )}
                  >
                    {'風味標籤'}
                  </div>
                </div>
                <div className={css(styles.flex1_spacer)} />
                <div className={css(styles.flex1_item1)}>
                  <div
                    className={css(
                      styles.small_paragraph_body,
                      styles.small_paragraph_body_layout
                    )}
                  >
                    {
                      '焦糖、南島暖陽、山徑小黃花、輕土香、溫和的中式糕點、熱帶闊葉林'
                    }
                  </div>
                </div>
              </div>

              <div className={css(styles.flex2, styles.flex2_layout)}>
                <div className={css(styles.flex2_item)}>
                  <div
                    className={css(
                      styles.cover_group5,
                      styles.cover_group5_layout
                    )}
                  >
                    <div
                      className={css(
                        styles.small_text_body,
                        styles.small_text_body_layout
                      )}
                    >
                      {'茶體'}
                    </div>
                  </div>
                </div>
                <div className={css(styles.flex2_spacer)} />
                <div
                  className={css(
                    styles.small_text_body1,
                    styles.small_text_body1_layout
                  )}
                >
                  {'輕盈'}
                </div>
                <div className={css(styles.flex2_spacer1)} />
                <div className={css(styles.flex2_item1)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/c0919a080cdded71ac4e6bab29a34188.svg')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout2)}
                  />
                </div>
                <div className={css(styles.flex2_item2)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/c61c2a6a76dee49314bcbc79739d5ab8.svg')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout3)}
                  />
                </div>
                <div className={css(styles.flex2_item3)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/cc781a545e3d4fbb548523e37254ae91.svg')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout4)}
                  />
                </div>
                <div className={css(styles.flex2_item4)}>
                  <div className={css(styles.group2, styles.group2_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/4089a3ad879891fd4cf34c7947bc080a.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout5)}
                    />
                  </div>
                </div>
                <div className={css(styles.flex2_item5)}>
                  <div className={css(styles.group3, styles.group3_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/21bb98fbb0f3864a68eb2de6b4095965.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout6)}
                    />
                  </div>
                </div>
              </div>

              <div className={css(styles.flex3, styles.flex3_layout)}>
                <div className={css(styles.flex3_item)}>
                  <div
                    className={css(
                      styles.cover_group6,
                      styles.cover_group6_layout
                    )}
                  >
                    <div
                      className={css(
                        styles.small_text_body,
                        styles.small_text_body_layout
                      )}
                    >
                      {'泡法'}
                    </div>
                  </div>
                </div>
                <div className={css(styles.flex3_spacer)} />
                <div className={css(styles.flex3_item1)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/8256fb8e4c4e8d1cbccf18b12b20b940.png')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout7)}
                  />
                </div>
                <div className={css(styles.flex3_spacer1)} />
                <div
                  className={css(
                    styles.small_text_body3_box,
                    styles.small_text_body3_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body3)}>
                    <span className={css(styles.small_text_body3_span0)}>
                      {'200ml'}
                    </span>
                    <span className={css(styles.small_text_body3_span1)}>
                      {' 熱泡'}
                    </span>
                  </div>
                </div>
                <div className={css(styles.flex3_spacer2)} />
                <div className={css(styles.flex3_item2)}>
                  <div
                    style={{
                      '--src': `url(${
                        require('assets/cad9bcf9ad1371a1a2b9462ed3feb802.png')
                          .default
                      })`
                    }}
                    className={css(styles.image, styles.image_layout8)}
                  />
                </div>
                <div className={css(styles.flex3_spacer3)} />
                <div
                  className={css(
                    styles.small_text_body4_box,
                    styles.small_text_body4_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body4)}>
                    <span className={css(styles.small_text_body4_span0)}>
                      {'300ml'}
                    </span>
                    <span className={css(styles.small_text_body4_span1)}>
                      {' 熱泡'}
                    </span>
                  </div>
                </div>
              </div>

              <div className={css(styles.flex4, styles.flex4_layout)}>
                <div
                  className={css(
                    styles.small_text_body5_box,
                    styles.small_text_body5_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body5)}>
                    <span className={css(styles.small_text_body5_span0)}>
                      {'茶葉 '}
                    </span>
                    <span className={css(styles.small_text_body5_span1)}>
                      {'3g'}
                    </span>
                    <span className={css(styles.small_text_body5_span2)}>
                      {' / 茶包'}
                    </span>
                    <span className={css(styles.small_text_body5_span3)}>
                      {'1'}
                    </span>
                    <span className={css(styles.small_text_body5_span4)}>
                      {'個'}
                    </span>
                  </div>
                </div>
                <div className={css(styles.flex4_spacer)} />
                <div
                  className={css(
                    styles.small_text_body6_box,
                    styles.small_text_body6_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body6)}>
                    <span className={css(styles.small_text_body6_span0)}>
                      {'茶葉 '}
                    </span>
                    <span className={css(styles.small_text_body6_span1)}>
                      {'3g'}
                    </span>
                    <span className={css(styles.small_text_body6_span2)}>
                      {' / 茶包'}
                    </span>
                    <span className={css(styles.small_text_body6_span3)}>
                      {'1'}
                    </span>
                    <span className={css(styles.small_text_body6_span4)}>
                      {'個'}
                    </span>
                  </div>
                </div>
              </div>

              <div className={css(styles.flex5, styles.flex5_layout)}>
                <div
                  className={css(
                    styles.small_text_body7_box,
                    styles.small_text_body7_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body7)}>
                    <span className={css(styles.small_text_body7_span0)}>
                      {'水溫：'}
                    </span>
                    <span className={css(styles.small_text_body7_span1)}>
                      {'95-98°C'}
                    </span>
                  </div>
                </div>
                <div className={css(styles.flex5_spacer)} />
                <div
                  className={css(
                    styles.small_text_body8_box,
                    styles.small_text_body8_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body8)}>
                    <span className={css(styles.small_text_body8_span0)}>
                      {'水溫：'}
                    </span>
                    <span className={css(styles.small_text_body8_span1)}>
                      {'95-98°C'}
                    </span>
                  </div>
                </div>
              </div>

              <div className={css(styles.flex6, styles.flex6_layout)}>
                <div
                  className={css(
                    styles.small_text_body9_box,
                    styles.small_text_body9_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body9)}>
                    <span className={css(styles.small_text_body9_span0)}>
                      {'時間：'}
                    </span>
                    <span className={css(styles.small_text_body9_span1)}>
                      {'2'}
                    </span>
                    <span className={css(styles.small_text_body9_span2)}>
                      {'分鐘'}
                    </span>
                  </div>
                </div>
                <div className={css(styles.flex6_spacer)} />
                <div
                  className={css(
                    styles.small_text_body10_box,
                    styles.small_text_body10_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body10)}>
                    <span className={css(styles.small_text_body10_span0)}>
                      {'時間：'}
                    </span>
                    <span className={css(styles.small_text_body10_span1)}>
                      {'3'}
                    </span>
                    <span className={css(styles.small_text_body10_span2)}>
                      {'分鐘'}
                    </span>
                  </div>
                </div>
              </div>

              <div className={css(styles.flex7, styles.flex7_layout)}>
                <div
                  className={css(
                    styles.small_text_body11_box,
                    styles.small_text_body11_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body11)}>
                    <span className={css(styles.small_text_body11_span0)}>
                      {'回沖：'}
                    </span>
                    <span className={css(styles.small_text_body11_span1)}>
                      {'3'}
                    </span>
                    <span className={css(styles.small_text_body11_span2)}>
                      {'次'}
                    </span>
                  </div>
                </div>
                <div className={css(styles.flex7_spacer)} />
                <div
                  className={css(
                    styles.small_text_body12_box,
                    styles.small_text_body12_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body12)}>
                    <span className={css(styles.small_text_body12_span0)}>
                      {'回沖'}
                    </span>
                    <span className={css(styles.small_text_body12_span1)}>
                      {'：'}
                    </span>
                    <span className={css(styles.small_text_body12_span2)}>
                      {'2'}
                    </span>
                    <span className={css(styles.small_text_body12_span3)}>
                      {'次'}
                    </span>
                  </div>
                </div>
              </div>

              <div
                onClick={() =>
                  window.open(
                    'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=6'
                  )
                }
                className={`${css(
                  styles.cover_group7,
                  styles.cover_group7_layout
                )} cursor-pointer to-more`}
              >
                {'了解更多'}
              </div>

              <div
                onClick={() => window.open('/', '_self')}
                className={`${css(
                  styles.cover_group8,
                  styles.cover_group8_layout
                )} cursor-pointer to-home`}
              >
                {/* link to 此測驗的首頁 */}
                <div
                  className={css(styles.background, styles.background_layout)}
                />
                <h5
                  className={css(styles.highlights4, styles.highlights4_layout)}
                >
                  {'重新探索'}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_box_spacer)} />
      </div>
    </div>
  );
}

SOUL1.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    backgroundColor: 'rgba(243,112,82,0.2)',
    borderRadius: '0px 0px 0px 0px'
  },
  group_layout: {
    position: 'relative',
    flexGrow: 1
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    width: '100%',
    height: '100%'
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    height: 268,
    flexGrow: 1,
    margin: '101px 144px',
    '@media (max-width: 1199.98px)': {
      margin: '51px 72px'
    },
    '@media (max-width: 991.98px)': {
      margin: '26px 36px'
    },
    '@media (max-width: 767.98px)': {
      margin: '25px 18px'
    },
    '@media (max-width: 575.98px)': {
      margin: '25px 10px'
    }
  },
  decorator: {
    background: 'var(--src) center center / contain no-repeat'
  },
  decorator_layout: {
    position: 'absolute',
    height: 136,
    width: 136,
    minWidth: 136,
    margin: '82px 0px 50px',
    inset: '0px 0px auto auto',
    '@media (max-width: 991.98px)': {
      margin: '41px 0px 25px'
    },
    '@media (max-width: 767.98px)': {
      margin: '25px 0px'
    }
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat'
  },
  icon_layout: {
    position: 'absolute',
    height: 82,
    width: 82,
    minWidth: 82,
    margin: '0px 0px 186px',
    inset: '0px auto auto 93px',
    '@media (max-width: 991.98px)': {
      margin: '0px 0px 93px'
    },
    '@media (max-width: 767.98px)': {
      margin: '0px 0px 47px'
    },
    '@media (max-width: 575.98px)': {
      margin: '0px 0px 24px'
    }
  },
  content_box: {
    display: 'flex'
  },
  content_box_layout: {
    position: 'relative',
    minHeight: 1663,
    flexGrow: 1
  },
  content_box_item: {
    display: 'flex',
    flex: '1 1 533px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 196,
    width: '21.76%',
    minWidth: 'min-content',
    margin: '153px auto 1314px',
    '@media (max-width: 991.98px)': {
      width: '40.17%'
    },
    '@media (max-width: 767.98px)': {
      width: '45.63%'
    }
  },
  content_box_item1: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 375
  },
  cover_group1: {
    display: 'flex',
    backgroundColor: 'rgb(253,226,221)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    width: 375,
    minWidth: 375
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '54px 15px'
  },
  component: {
    flex: '0 0 auto'
  },
  component_layout: {
    margin: '0px 1px'
  },
  cover_group2: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group2_layout: {
    position: 'relative',
    flex: '0 0 auto',
    minHeight: 257,
    margin: '39px 1px 0px'
  },
  image_layout1: {
    height: 155,
    width: 89,
    minWidth: 89,
    margin: '102px 46px 0px auto'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69875
  },
  highlights_layout: {
    flex: '0 0 auto',
    margin: '16px 1px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    '@media (max-width: 991.98px)': {
      fontSize: '29px',
      textAlign: 'left'
    },
    '@media (max-width: 767.98px)': {
      fontSize: '25px'
    }
  },
  big_title_layout: {
    flex: '0 0 auto',
    margin: '8px 1px 0px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flex: '0 0 auto',
    margin: '22px 1px 0px'
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group3_layout: {
    position: 'relative',
    flex: '0 0 auto',
    height: 44,
    margin: '10px 1px 0px'
  },
  image2: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image2_layout: {
    flex: '0 0 auto',
    height: 257,
    margin: '44px 0px 0px 1px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    flex: '0 0 auto',
    margin: '21px 1px 0px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flex: '0 0 auto',
    margin: '7px 1px 0px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '0 0 auto',
    margin: '45px 1px 0px'
  },
  paragraph_body_layout1: {
    flex: '0 0 auto',
    margin: '15px 1px 0px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '12px 1px 0px'
  },
  flex1_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group4: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    justifyContent: 'flex-end',
    padding: '0px 5px 0px 5px'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '0px 0px 24px'
  },
  flex1_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex1_item1: {
    display: 'flex',
    flex: '0 1 276px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    flexGrow: 1
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '6px 1px 0px'
  },
  flex2_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group5: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group5_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '2px 0px'
  },
  small_text_body: {
    display: 'flex',
    justifyContent: 'flex-end',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    width: 'fit-content',
    margin: '0px auto'
  },
  flex2_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body1: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    flex: '0 0 auto',
    margin: '2px 0px'
  },
  flex2_spacer1: {
    flex: '0 0 auto',
    minWidth: 9
  },
  flex2_item1: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 13
  },
  image_layout2: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '5px 0px 7px'
  },
  flex2_item2: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 13
  },
  image_layout3: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '5px 0px 7px'
  },
  flex2_item3: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 13
  },
  image_layout4: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '5px 0px 7px'
  },
  flex2_item4: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 14
  },
  group2: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '2px 0px 4px'
  },
  image_layout5: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex2_item5: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 14
  },
  group3: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '2px 0px 4px'
  },
  image_layout6: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '6px 1px 0px'
  },
  flex3_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group6: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group6_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '2px 0px'
  },
  flex3_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex3_item1: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 18
  },
  image_layout7: {
    height: 11,
    width: 18,
    minWidth: 18,
    margin: '6.5px 0px'
  },
  flex3_spacer1: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body3: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body3_box: {},
  small_text_body3_box_layout: {
    flex: '0 0 auto',
    margin: '2px 0px'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex3_spacer2: {
    flex: '0 0 auto',
    minWidth: 40
  },
  flex3_item2: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 18
  },
  image_layout8: {
    height: 13,
    width: 18,
    minWidth: 18,
    margin: '5.5px 0px'
  },
  flex3_spacer3: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body4: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '0 0 auto',
    margin: '2px 0px'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex4: {
    display: 'flex'
  },
  flex4_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '0px 59px 0px 68px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {},
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex4_spacer: {
    flex: '0 1 30px'
  },
  small_text_body6: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body6_box: {},
  small_text_body6_box_layout: {},
  small_text_body6_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex5: {
    display: 'flex'
  },
  flex5_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '0px 68px'
  },
  small_text_body7: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {},
  small_text_body7_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex5_spacer: {
    flex: '0 1 45px'
  },
  small_text_body8: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body8_box: {},
  small_text_body8_box_layout: {},
  small_text_body8_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex6: {
    display: 'flex'
  },
  flex6_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '0px 68px'
  },
  small_text_body9: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body9_box: {},
  small_text_body9_box_layout: {},
  small_text_body9_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex6_spacer: {
    flex: '0 1 57px'
  },
  small_text_body10: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body10_box: {},
  small_text_body10_box_layout: {},
  small_text_body10_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex7: {
    display: 'flex'
  },
  flex7_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '0px 68px'
  },
  small_text_body11: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body11_box: {},
  small_text_body11_box_layout: {},
  small_text_body11_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex7_spacer: {
    flex: '0 1 69px'
  },
  small_text_body12: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body12_box: {},
  small_text_body12_box_layout: {},
  small_text_body12_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12_span2: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body12_span3: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  cover_group7: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cover_group7_layout: {
    position: 'relative',
    flex: '0 0 auto',
    minHeight: 44,
    margin: '12px 1px 0px'
  },
  cover_group8: {
    display: 'flex'
  },
  cover_group8_layout: {
    position: 'relative',
    flex: '0 0 auto',
    minHeight: 44,
    margin: '16px 1px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    minHeight: 44,
    flexGrow: 1,
    inset: 0
  },
  highlights4: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  },
  content_box_spacer: {
    flex: '1 1 532px'
  }
});
